import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  // Close on Escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-230">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-8" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" data-id="element-231">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-navy-950/80 backdrop-blur-sm" data-id="element-232" />

          {/* Modal panel */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} onClick={e => e.stopPropagation()} className="relative bg-navy-900 border border-gold-500/20 rounded-2xl max-w-2xl w-full max-h-[85vh] flex flex-col shadow-[0_20px_80px_rgba(0,0,0,0.6)]" data-id="element-233">
            {/* Header */}
            <div className="flex items-center justify-between p-6 md:p-8 border-b border-navy-800 shrink-0" data-id="element-234">
              <h2 id="legal-modal-title" className="text-2xl md:text-3xl font-serif font-bold text-gradient-gold" data-id="element-235">
                {title}
              </h2>
              <button onClick={onClose} aria-label="Cerrar" className="w-10 h-10 rounded-full border border-navy-700 hover:border-gold-500/40 text-gray-400 hover:text-gold-400 flex items-center justify-center transition-colors" data-id="element-236">
                <X className="w-5 h-5" data-id="element-237" />
              </button>
            </div>

            {/* Content (scrollable) */}
            <div className="overflow-y-auto p-6 md:p-8 text-gray-300 leading-relaxed space-y-4 font-light text-sm md:text-base legal-content" data-id="element-238">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}